import { render, staticRenderFns } from "./SettingsSign.vue?vue&type=template&id=341110b5&"
import script from "./SettingsSign.vue?vue&type=script&lang=js&"
export * from "./SettingsSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports